import { X, Trophy } from 'lucide-react';

interface ExamNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

export default function ExamNoticeModal({ isOpen, onClose, title, message }: ExamNoticeModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white dark:bg-slate-900 rounded-3xl shadow-2xl p-8 w-full max-w-md animate-in zoom-in-95 duration-200 border border-border">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex flex-col items-center text-center mt-2">
          <div className="w-16 h-16 bg-accent-100 dark:bg-accent-500/10 text-accent-600 dark:text-accent-500 rounded-full flex items-center justify-center mb-6 shadow-sm border border-accent-200 dark:border-accent-800/50">
            <Trophy size={32} />
          </div>

          <h2 className="text-2xl font-black text-slate-900 dark:text-white mb-3">
            {title}
          </h2>

          <p className="text-slate-500 dark:text-slate-400 font-medium mb-8 leading-relaxed">
            {message}
          </p>

          <button
            onClick={onClose}
            className="w-full py-3.5 bg-accent-500 hover:bg-accent-600 text-white font-black rounded-xl transition-all shadow-lg shadow-accent-500/20 active:scale-95 flex items-center justify-center"
          >
            Teşekkürler
          </button>
        </div>
      </div>
    </div>
  );
}
